class HighEnergyNavigation {
  constructor(navigation, toggles) {
    this.ACTIVE_CLASS = 'active';
    this.navigation = navigation;
    this.toggles = toggles;

    window.addEventListener('scroll', this.handleScroll);

    Array.forEach(this.toggles, toggle => {
      toggle.addEventListener('click', this.handleToggleClick);
    });
  }

  handleToggleClick = () => {
    this.navigation.classList.toggle(this.ACTIVE_CLASS);
  };

  handleScroll = () => {
    if (window.pageYOffset > 70) {
      this.navigation.classList.add(this.ACTIVE_CLASS);
    } else {
      this.navigation.classList.remove(this.ACTIVE_CLASS);
    }
  };
}

$(document).ready(() => {
  const navigation = document.querySelector('.js-he-navigation');
  const toggles = document.querySelectorAll('.js-he-navigation-toggle');

  if (navigation !== null && toggles !== null) {
    // eslint-disable-next-line
    new HighEnergyNavigation(navigation, toggles);
  }
});
